import React, {useState} from "react";

export default function WeatherTemperature (props) {
    const [unit, setUnit]= useState("metrics");
    function showFahrenheit(event) {
        event.preventDefault();
        setUnit("imperial");
    }
    function showCelsius(event) {
        event.preventDefault();
        setUnit("metrics");
    }
    if(unit==="metrics"){return (
        <div>
    <strong id="temp-today">{Math.round(props.celsius)} </strong>
    <span class="units">
      {" "}
      <span>
        °C{" "}
      </span>{" "}
      |{" "}
      <a href="/" onClick={showFahrenheit} id="fahrenheit">
        °F
      </a>
    </span>
    </div>);} 
    else {
        let fahrenheit = (props.celsius*9/5)+32;
        return(
        <div>
    <strong id="temp-today">{Math.round(fahrenheit)} </strong>
    <span class="units">
      {" "}
      <a href="/" onClick={showCelsius} >
        °C{" "}
      </a>{" "}
      |{" "}
      <span id="fahrenheit">
        °F
      </span>
    </span>
    </div>
    );
}
    
}